import propertyTypeDropdown from "../components/propertyTypeDropdown";
import header from "../components/header/header";
import dom from "../../../common/ts/core/dom";
import homeSearchBoxForm from "../components/homeSearchBoxForm";

dom.init();
header.init();
propertyTypeDropdown.init();
homeSearchBoxForm.init();
